import { SET_USER } from "../actions/userActions";

export default function reducer(state = {}, action) {
    switch (action.type) {
        case SET_USER:
            return {
                ...state,
                ...action.user,
            };

        default:
    }
    return state;
}
